import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import "./SkuCard.scss";

import imgWallMountDirectIndirect from "../../../img/mount-direct-indirect.png";
import imgSwatchBlack from '../../../img/SwatchBlack.jpg';
import imgSwatchWhite from '../../../img/SwatchWhite.jpg';
import imgSwatchGraphite from '../../../img/SwatchGranite.jpg';
// import imgWallMountDirect from '../../../img/mount-direct.png';
// import imgMountRecessed from '../../../img/mount-recessed.png';
// import imgMountSurface from '../../../img/mount-surface.png';
// import imgMountSuspendedDirectIndirect from '../../../img/mount-suspended-direct-indirect.png';
// import imgMountSuspendedDirect from '../../../img/mount-suspended-direct.png';

import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import NumericInput from "react-numeric-input";

// import downloadMappings from "../../../download_mappings.json";

import _ from "lodash";
import { classImplements } from "@babel/types";
import { Grid } from "@material-ui/core";

import ACTIONS from "../../../actions/action";
import { connect } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  // card: {
  //   padding: theme.spacing(3),
  //   marginTop: theme.spacing(1),
  //   marginBottom: theme.spacing(3)
  // },
  media: {
    //height: 0,
    //paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: 10,
    marginTop: 4,
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    //backgroundColor: red[500],
  },
  button: {
    margin: theme.spacing(1)
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  downloadsRoot: {
    display: "flex",
    margin: theme.spacing(2)
  },
  deleteModalRoot: {
    padding: theme.spacing(2)
  },
  // linkRoot: {
  //   width: "45%",
  //   padding: "2%",
  //   backgroundColor: "#efefef",
  //   margin: "1%"
  // },
  documentLink: {
    fontSize: 14
  },
  deleteOutlinedIcon: {
    cursor:'pointer'
  }
}));

export const mounting_options_readable = {
    SF:"Surface Mount",
    SD:"Suspended Direct",
    SI:"Suspended Direct/Indirect",
    WD:"Wall Mount Direct",
    WI:"Wall Mount Direct/Indirect",
    RC:"Recessed"
}

export const configurations_readable = {
  Blank:"Linear",
  S:"Square",
  R:"Rectangle",
  U:"U-Shaped",
  L:"L-Shaped",
  C:"Custom"
}

export const spec_sheet = {
    SF:"https://www.creelink.com/exLink.asp?47026320OW82S33I71255760&view=1",
    SD:"https://www.creelink.com/exLink.asp?47057222OY78C91I56714614&view=1",
    SI:"https://www.creelink.com/exLink.asp?45056314OX24K73I58379175&view=1",
    WD:"https://www.creelink.com/exLink.asp?47083959OJ32W88I56719641&view=1",
    WI:"https://www.creelink.com/exLink.asp?47076848OL81U86I56724668&view=1",
    RC:"https://www.creelink.com/exLink.asp?47033430OM18G75I56699533&view=1"
}

export const low_medium_high = {
  L:"Low",
  M:"Medium",
  H:"High"
}

export const cri_readable ={
  "Blank":"90 CRI",
  "8":"80 CRI"
}

export const cri_map ={
  "Blank":"",
  "8":80
}

export const cct_readable = {
  "30K":"3000 K",
  "35K":"3500 K",
  "40K":"4000 K"
}

export const voltage_readable = {
  "Blank":"120-277v",
  "34":"347v"
}

export const downlight_optic_readable = {
  L:"Lambertian",
  W:"Wall Wash"
}

export const controls_readable = {
  "10V":"0-10V Dimming",
  "DAL":"Dali",
  "LDE5":"Lutron ECO",
  "VDO":"Lutron Vive",
  "CMA":"Smartcast"
}

export const ceiling_type_readable = {
  A:"1” T bar",
  B:"9/16” T bar",
  C:"Screw Slot T bar",
  D:"Hard Ceiling",
  E:"1” Tegular",
  F:"9/16” Tegular",
  G:"Overlap Flange"
}

export const color_readable = {
  WH:"White",
  BK:"Black",
  GR:"Graphite"
}

export const additional_options_readable = {
  N:"None",
  EB:"10W Emergency Battery  Backup",
  GT:"Generator Transfer Device",
  DF:"Dual Feed",
  EBDF:"10W Emergency Battery  Backup with Dual Feed"
}

export const downloadMappings = require( "../../../download_mappings.json");

function SkuCard(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(true);
  const [deleteOpen, setDeleteOpen] = React.useState(false);

  const { config, index, editBom, deleteConfig } = props;
  const [totalFeet, setTotalFeet] = React.useState(config.length);

  // let configLength = config.length;
  // if (config.length < 10) configLength = "0" + configLength;

  let productSKU = [
    "ST3",
    config.mountingOptions,
    config.length,
    config.uplightOutput,
    config.downlightOutput,
    config.cct,
    config.downlightOptic,
    config.controls,
    config.suspensionLength,
    config.ceilingType,
    config.color
  ];

  if(config.cri != "Blank")
    productSKU.splice(5, 0, config.cri);

  
    if(config.voltage != "Blank"){
      if(config.cri != "Blank"){
        productSKU.splice(7, 0, config.voltage);
      }else{
        productSKU.splice(6, 0, config.voltage);
      }
    }

  if(config.additionalOptions != "N")
    productSKU.push(config.additionalOptions);

  function handleExpandClick() {
    setExpanded(!expanded);
  }

  function handleQuantity(event, value) {
    
    let lengthVal;
    console.log("config:", config)
    if(config["configurations"] == "S"){
      //Square: Multiply side value by 4 for linear feet
      lengthVal = Number.isInteger(parseInt(config.length)) ? parseInt(config.length) : (parseInt(config.sideA) * 4);
    }else if(config["configurations"] == "R"){
      //Rect: Multiply each side value by 2 and add for linear feet
      lengthVal = Number.isInteger(parseInt(config.length)) ? parseInt(config.length) : (parseInt(config.sideA) * 2) + (parseInt(config.sideB) * 2);
    }else{
      //Add all length values for other configurations for linear feet
      lengthVal = Number.isInteger(parseInt(config.length)) ? parseInt(config.length) : parseInt(config.sideA) + parseInt(config.sideB) + parseInt(config.sideC);
    }

    config.quantity = value;
    config.tlf = lengthVal * value;

    editBom({index:index,data:config});

  }

  function handleDelete(){
    setDeleteOpen(false);
    handleMenuClose();
    deleteConfig({index:index});
  }

  function handleDeleteModalOpen() {
    setDeleteOpen(true);
  }

  function handleDeleteModalClose() {
    setDeleteOpen(false);
    handleMenuClose();
  }

  /*
  {
    "Mounting": "SF",
    "Uplight Level": "",
    "Downlight Level": "L",
    "Length": "02",
    "Spec": "Styllus Series_Surface Architectural_SpecSheet_V",
    "IES": "2 ft direct low IES File"
  }
  */

//  {
//   "Mounting": "SI",
//   "Uplight Level": "L",
//   "Downlight Level": "L",
//   "Length": 2,
//   "Spec": "Styllus Series_Suspended Direct_Indirect_Architectural_SpecSheet_V",
//   "IES Description": "2 ft direct low and Suspended Indirect low IES File",
//   "Instruction File": "Styllus Work Instructions for IES Files",
//   "Instruction File Link": "https://www.creelink.com/exLink.asp?49140882OE24U92I59839880",
//   "IES File1": "ST3-SI-02-L-L-xxK-L-xxxx_CONFIGURED",
//   "Link1": "https://www.creelink.com/exLink.asp?47671645OA38E47I91007413",
//   "IES File2": "",
//   "Link2": "",
//   "IES File3": "",
//   "Link3": "",
//   "Completed": "x"
// },

  let dimensions = "";
  if(config.configurations != "C"){
    if(Number.isInteger(parseInt(config.length))){
      dimensions = parseInt(config.length);
    }else{
      if(config.configurations != "S"){
        dimensions = parseInt(config.sideA) + "'";
        if(parseInt(config.sideB) > 0){
          dimensions += "x" + parseInt(config.sideB) + "'";
        }
        if(parseInt(config.sideC) > 0){
          dimensions += "x" + parseInt(config.sideC) + "'";
        }
      }else{
        dimensions = parseInt(config.sideA) + "'x" + parseInt(config.sideA) +"'";
      }

    }
  }else{
    dimensions = parseInt(config.sideA);
  }

  // debugger;
  console.log("Mounting:", config.mountingOptions);
  console.log("Uplight Level:", config.uplightOutput?config.uplightOutput:"");
  console.log("Downlight Level:", config.downlightOutput);
  console.log("Length:", config["configurations"] == "Blank" ? parseInt(config.length) : 2);
  console.log("CRI:", cri_map[config.cri]);
  console.log("Downlight Distribution:", downlight_optic_readable[config.downlightOptic]);

  let documents = _.find(downloadMappings,{
    "Mounting": config.mountingOptions,
    "Uplight Level": config.uplightOutput?config.uplightOutput:"",
    "Downlight Level": config.downlightOutput,
    "Length": config["configurations"] == "Blank" ? parseInt(config.length) : 2,
    "CRI": cri_map[config.cri],
    "Downlight Distribution": downlight_optic_readable[config.downlightOptic]
  });


// debugger;
  if(documents){
    if(documents["Link"]){
      console.log("Documents:", documents);

      console.log("length:", documents["Length"]);

    }else{
      console.log("Documents:", documents);

      console.log("Documents:", documents["Instruction File"]);
      console.log("Documents:", documents["Instruction File Link"]);
      console.log("Documents:", documents["IES File1"]);
      console.log("Documents:", documents["Link1"]);
      console.log("Documents:", documents["IES File2"]);
      console.log("Documents:", documents["Link2"]);
      console.log("Documents:", documents["IES File3"]);
      console.log("Documents:", documents["Link3"]);

      console.log("length:", documents["Length"]);

    }
  }else{
    console.log("No documents found.");
  }

  

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  function handleMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  return (
    <Card className="skuCard" square>
      <IconButton
          aria-label="More"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleMenuOpen}
          className="deleteButton"
        >
          <MoreIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            // style: {
            //   maxHeight: ITEM_HEIGHT * 4.5,
            //   width: 200,
            // },
          }}
        >
            <MenuItem onClick={handleDeleteModalOpen}>
              Delete
            </MenuItem>
        </Menu>
      <div className="skuCardHeader">
        <div className="skuCardImg">
          {config.color == "BK" && <img src={imgSwatchBlack} alt="Styllus Image" />}
          {config.color == "WH" && <img src={imgSwatchWhite} alt="Styllus Image" />}
          {config.color == "GR" && <img src={imgSwatchGraphite} alt="Styllus Image" />}
          {!config.color && <img src={imgWallMountDirectIndirect} alt="Styllus Image" />}
        </div>
        <div className="skuCardTitle">
          <Typography variant="caption">SKU Number</Typography>
          <Typography variant="h3">
            {productSKU.filter(x => x).join("-")}
          </Typography>
        </div>
      </div>
      <div className="skuCardInputs">
        <div className="skuQuantity">
          <InputLabel>Quantity:</InputLabel>
          <NumericInput
            className="form-control"
            min={1}
            max={100}
            defaultValue={config.quantity}
            onChange={handleQuantity}
          />
        </div>
        <div className="skuFeet">
          <InputLabel>Total Linear Feet:</InputLabel>
          <div className="skuFeetValue">{config.configurations != "C" ? config.tlf : "N/A"}</div>
        </div>
      </div>
      <Typography
        className="skuDetailsToggle"
        variant="h6"
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="Show more"
      >
        Product Details
        <ExpandMoreIcon
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
        />
      </Typography>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className="skuDetails">
          <div className="skuDetailItem">
            <div>Mounting Options</div>
            <div className="skuDetailValue">{mounting_options_readable[config.mountingOptions]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Configuration</div>
            <div className="skuDetailValue">{configurations_readable[config.configurations]}</div>
          </div>
          <div className="skuDetailItem">
            <div>{config["configurations"] != "C" ? "Length/Linear Feet" : "Corners"}</div>
            <div className="skuDetailValue">
              {dimensions}
            {/* {config["configurations"] != "C" ?
              Number.isInteger(parseInt(config.length)) ?
                config.length < 10 ? 
                    // Prevents leading 0
                    parseInt(config.length) + " Feet"
                  : 
                    config.length + " Feet"
              :
                // dimensions here
            :
              parseInt(config.sideA)
            } */}
            </div>
          </div>
          <div className="skuDetailItem">
            <div>Uplight Output</div>
            <div className="skuDetailValue">{config.uplightOutput ? low_medium_high[config.uplightOutput] : "N/A"}</div>
          </div>
          <div className="skuDetailItem">
            <div>Downlight Output</div>
            <div className="skuDetailValue">{low_medium_high[config.downlightOutput]}</div>
          </div>
          <div className="skuDetailItem">
            <div>CRI</div>
            <div className="skuDetailValue">{cri_readable[config.cri]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Correlated Color Temperatures (CCT)</div>
            <div className="skuDetailValue">{cct_readable[config.cct]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Voltage</div>
            <div className="skuDetailValue">{config.voltage ? voltage_readable[config.voltage] : "N/A"}</div>
          </div>
          <div className="skuDetailItem">
            <div>Downlight Optic</div>
            <div className="skuDetailValue">{downlight_optic_readable[config.downlightOptic]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Controls</div>
            <div className="skuDetailValue">{controls_readable[config.controls]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Suspension Length </div>
            <div className="skuDetailValue">{config.suspensionLength ? config.suspensionLength < 10 ? parseInt(config.suspensionLength) + " Feet" : config.suspensionLength + " Feet" : "N/A"} </div>
          </div>
          <div className="skuDetailItem">
            <div>Ceiling Type</div>
            <div className="skuDetailValue">{config.ceilingType ? ceiling_type_readable[config.ceilingType] : "N/A"}</div>
          </div>
          <div className="skuDetailItem">
            <div>Luminaire Color</div>
            <div className="skuDetailValue">{color_readable[config.color]}</div>
          </div>
          <div className="skuDetailItem">
            <div>Additional Options</div>
            <div className="skuDetailValue">{additional_options_readable[config.additionalOptions]}</div>
          </div>
        </div>
        <p className="custom-config-disclaimer">*For custom configurations, a sales representivie will contact you for further details.</p>
      </Collapse>
      {documents &&
        <React.Fragment>
          <Typography
            className="no-print skuDetailsToggle"
            variant="h6"
          >
            Downloads
          </Typography>
          <div className="no-print download-links-root">
          <Grid container spacing={1}>

          <Grid item sm={6}>
            <div className="download-links">
              <i class="fa fa-file-pdf-o" style={{color:'red',marginRight:'5px'}}></i>
              <a className={classes.documentLink} href={documents["Spec Sheet"]} rel="noopener noreferrer" target="_blank">
                {documents["Spec"]}
              </a>
            </div>
            </Grid>

            {(documents["Instruction File Link"]) &&
            <Grid item sm={6}>
              <div className="download-links">
                <i class="fa fa-file-pdf-o" style={{color:'red',marginRight:'5px'}}></i>
                <a className={classes.documentLink} href={documents["Instruction File Link"]} rel="noopener noreferrer" target="_blank">
                  {documents["Instruction File"]}
                  </a>
              </div>
              </Grid>
            }
            
            {(documents["Mounting"] == "WD" ||
              documents["Mounting"] == "WI") && 
              documents["Link1"] && 
                <Grid item sm={6}>
                  <div className="download-links">
                    <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                    <a className={classes.documentLink} href={documents["Link1"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]}</a>
                  </div>
                </Grid>
            }

            {(documents["Mounting"] == "SD" ||
              documents["Mounting"] == "SF" ||
              documents["Mounting"] == "RC") && 
              documents["Link1"] && 
                  <Grid item sm={6}>
                    <div className="download-links">
                      <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                      <a className={classes.documentLink} href={documents["Link1"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Lambertian)</a>
                    </div>
                  </Grid>
            }

            {(documents["Mounting"] == "SD" ||
              documents["Mounting"] == "SF" ||
              documents["Mounting"] == "RC") && 
              documents["Link2"] && 
                <Grid item sm={6}>
                  <div className="download-links">
                    <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                    <a className={classes.documentLink} href={documents["Link2"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Wall Wash)</a>
                  </div>
                </Grid>
            }

            {documents["Mounting"] == "SI" &&
             documents["Downlight Distribution"] == "Lambertian" &&
             documents["Link1"] && 
                  <Grid item sm={6}>
                    <div className="download-links download-links-si">
                      <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                      <a className={classes.documentLink} href={documents["Link1"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Lambertian)</a>
                    </div>
                  </Grid>
              }

            {documents["Mounting"] == "SI" &&
             documents["Downlight Distribution"] == "Wall Wash" &&
             documents["Link1"] && 
                  <Grid item sm={6}>
                    <div className="download-links download-links-si">
                      <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                      <a className={classes.documentLink} href={documents["Link1"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Wall Wash)</a>
                    </div>
                  </Grid>
              }

            {documents["Mounting"] == "SI" &&
             documents["Downlight Distribution"] == "Lambertian" &&
             documents["Link2"] && 
                  <Grid item sm={6}>
                    <div className="download-links download-links-si">
                      <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                      <a className={classes.documentLink} href={documents["Link2"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Wall Wash)</a>
                    </div>
                  </Grid>
              }

            {documents["Mounting"] == "SI" &&
             documents["Downlight Distribution"] == "Wall Wash" &&
             documents["Link2"] && 
                  <Grid item sm={6}>
                    <div className="download-links download-links-si">
                      <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                      <a className={classes.documentLink} href={documents["Link2"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]} (Lambertian)</a>
                    </div>
                  </Grid>
              }


            {/* {documents["Link1"] && 
            <Grid item sm={6}>
              <div className="download-links">
                <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                <a className={classes.documentLink} href={documents["Link1"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]}</a>
              </div>
              </Grid>
            }
            {documents["Link2"] && 
            <Grid item sm={6}>
              <div className="download-links">
                <i class="fa fa-file-archive-o" style={{color:'blue',marginRight:'5px'}}></i>
                <a className={classes.documentLink} href={documents["Link2"]} rel="noopener noreferrer" target="_blank">{documents["IES Description"]}</a>
              </div>
              </Grid>
            } */}
            
            </Grid>
          </div>
        </React.Fragment>
      }
      <Dialog
        open={deleteOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDeleteModalClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle disableTypography id="alert-dialog-slide-title">{"Delete Configuration"}</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.deleteModalRoot} id="alert-dialog-slide-description">
            Are you sure you want to delete this configuration?
            <div className="delete-sku"><p><span>SKU Number</span> {productSKU.filter(x => x).join("-")}</p></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

export default SkuCard;